<template>
    <PageHeader :title="$t('online_overview.title')" @back="goBack" />

    <div class="flex flex-col gap-4 px-4 pt-4 pb-8">
        <div
            class="flex p-4 bg-red-600 clip-left-corner items-center gap-4 cursor-pointer"
            data-testid="private-match-button"
            @click="goToPrivateMatch"
        >
            <div class="flex flex-col flex-1 gap-2">
                <h2 class="font-title text-lg font-bold uppercase">{{ $t('online_overview.private_match_title') }}</h2>
                <span class="leading-5 text-sm max-w-2/3">{{ $t('online_overview.private_match_description') }}</span>
            </div>
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-1.23621e-07 12L5.29297 6.70703L-1.04907e-06 1.41406L1.41406 5.86347e-07L8.12109 6.70703L1.41406 13.4141L-1.23621e-07 12Z" fill="white"/>
            </svg>
        </div>
        <h2 class="font-title text-lg font-bold uppercase">{{ $t('online_overview.coming_soon') }}</h2>
        <div class="flex p-4 bg-zinc-900 clip-left-corner items-center gap-4 cursor-not-allowed relative">
            <svg width="78" height="96" viewBox="0 0 78 96" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute right-0 bottom-0 z-0">
                <path d="M27.756 7.50431C64.7419 -13.8158 111 12.826 111 55.5067C111 75.3132 100.415 93.61 83.244 103.509C46.2581 124.829 0.000174221 98.1878 0 55.5067C0 35.7007 10.5846 17.4035 27.756 7.50431ZM53.5789 98.5951C54.8495 98.6547 56.1263 98.6692 57.409 98.6132L71.2659 61.6734H39.734L53.5789 98.5951ZM71.7778 95.4335C73.5668 94.6962 75.3435 93.8324 77.0894 92.8259C88.6391 86.1669 96.3466 74.6255 98.221 61.6734H84.4424L71.7778 95.4335ZM12.7609 61.6734C14.9773 77.5389 25.6342 89.8373 39.2041 95.4034L26.5576 61.6734H12.7609ZM84.4424 49.3401H98.2391C96.0224 33.4718 85.3634 21.1687 71.7899 15.6041L84.4424 49.3401ZM53.585 12.3943L39.734 49.3401H71.2659L57.415 12.4123C56.1446 12.353 54.8675 12.3381 53.585 12.3943ZM39.2161 15.574C37.4282 16.311 35.6556 17.1817 33.9106 18.1876C22.3608 24.8466 14.6533 36.3882 12.779 49.3401H26.5576L39.2161 15.574Z" class="fill-card opacity-50"/>
            </svg>
            <div class="flex flex-col flex-1 gap-2 z-10">
                <h2 class="font-title text-lg font-bold uppercase text-titles">{{ $t('online_overview.create_public_match_title') }}</h2>
                <span class="leading-5 text-sm max-w-2/3 text-titles">{{ $t('online_overview.create_public_match_description') }}</span>
            </div>
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="z-10">
            <path d="M-1.23621e-07 12L5.29297 6.70703L-1.04907e-06 1.41406L1.41406 5.86347e-07L8.12109 6.70703L1.41406 13.4141L-1.23621e-07 12Z" fill="white"/>
            </svg>
        </div>
        <div class="flex p-4 bg-zinc-900 clip-left-corner items-center gap-4 cursor-not-allowed">
            <div class="flex flex-col flex-1 gap-2">
                <h2 class="font-title text-lg font-bold uppercase text-titles">{{ $t('online_overview.public_match_list_title') }}</h2>
            </div>
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-1.23621e-07 12L5.29297 6.70703L-1.04907e-06 1.41406L1.41406 5.86347e-07L8.12109 6.70703L1.41406 13.4141L-1.23621e-07 12Z" fill="white"/>
            </svg>
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'

export default {
    name: 'OnlineOverviewView',
    components: { PageHeader },
    methods: {
        goBack() {
            this.$router.back()
        },
        goToPrivateMatch() {
            this.$router.push({ name: 'game-selection-online' })
        },
    },
}
</script>
